var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpervaWaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(13 13)",
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0523 19.417H18.5V20.8994H20.0523V19.417Z",
    fill: "#FFFFFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0523 26.906H18.5V21.5912H20.0523V26.906ZM27.1882 21.4814C28.335 21.4814 29.0185 22.2391 29.0185 23.447V26.906H27.4778V23.7435C27.4778 23.1725 27.2114 22.7991 26.6785 22.7991C26.273 22.7991 25.9139 23.0407 25.8212 23.4909V26.917H24.2574V23.7435C24.2574 23.1725 24.0025 22.7991 23.4696 22.7991C23.0642 22.7991 22.6935 23.0407 22.6008 23.4909V26.917H21.0601V21.5912H22.6124V22.0304C22.8904 21.701 23.4001 21.4704 24.0141 21.4704C24.6744 21.4704 25.2073 21.7559 25.5085 22.1512C25.8676 21.7669 26.4005 21.4814 27.1882 21.4814Z",
    fill: "#FFFFFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0185 27.5978V29.0802H27.4662V27.5978H29.0185Z",
    fill: "#FFFFFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpervaWaf);
export default __webpack_public_path__ + "static/media/ImpervaWAF.a6bc32a8dd7b8fd173c6096d4cb42ade.svg";
export { ForwardRef as ReactComponent };